import { render, staticRenderFns } from "./priorityView.vue?vue&type=template&id=569caf74&"
import script from "./priorityView.vue?vue&type=script&lang=js&"
export * from "./priorityView.vue?vue&type=script&lang=js&"
import style0 from "./priorityView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports